import { render, staticRenderFns } from "./IssuesFormValidation.vue?vue&type=template&id=3d8b87a2"
import script from "./IssuesFormValidation.vue?vue&type=script&lang=js"
export * from "./IssuesFormValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports